import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import config from '../../../../application/config/config';

function List() {

    const pathFrontEnd = '/core/applications/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpoint: `${config.endpoints.backend}core/applications/getall`,
        endpointDelete: `${config.endpoints.backend}core/applications/delete`
    }

    const list = {
        labelTitle: 'Lista de aplicações',
        labelTitleButtonAdd: 'Incluir nova aplicação',
        fieldsShowOnDelete: ['application_name'],
        showPrintButtons: false,
        columns: [
            {
                name: 'application_name',
                label: 'Aplicação',
                width: '80%'
            }
        ],
        ...paths
    };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={list} />}
            />
        </div>
    );
}
export default List;
